module.exports = __webpack_public_path__ + "img/click-result.741c81a7.png";